'use client';

import { c as _c } from "react/compiler-runtime";
import { GenuinePartItem } from '@/app/components/sections/service/parts/genuine-part-table/genuine-item';
import { PartItem } from '@/app/components/sections/service/parts/genuine-part-table/part-item';
import { type GenuinePartTableProps } from '@/app/components/sections/service/parts/types';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import { Enum_Componentservicesgenuinepart_Genuineparttype } from '@/types/tis-cms/types';
export const GenuinePartTable = t0 => {
  const $ = _c(9);
  const {
    categoryUrl,
    genuineParts: t1,
    testId
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const genuineParts = t2;
  let t3;
  if ($[2] !== genuineParts) {
    t3 = genuineParts.filter(_temp);
    $[2] = genuineParts;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const isGenuinePart = t3.length > 0;
  let t4;
  if ($[4] !== categoryUrl || $[5] !== genuineParts || $[6] !== isGenuinePart || $[7] !== testId) {
    t4 = <>{isGenuinePart ? <div className="flex flex-col items-stretch justify-evenly gap-2 md:gap-3 xl:flex-row" {...createDataAttributes({
        test: `${testId}-genuine-table`
      })}>{genuineParts.map((o, i) => <GenuinePartItem key={i} index={i} genuinePart={o} testId={testId} />)}</div> : <div className="bg-silver-50 flex flex-col rounded-sm p-4" {...createDataAttributes({
        test: `${testId}-part-table`
      })}>{genuineParts.map((o_0, i_0) => <PartItem key={i_0} index={i_0} categoryUrl={categoryUrl} genuinePart={o_0} testId={testId} />)}</div>}</>;
    $[4] = categoryUrl;
    $[5] = genuineParts;
    $[6] = isGenuinePart;
    $[7] = testId;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
function _temp(p) {
  return p?.genuinePartType !== Enum_Componentservicesgenuinepart_Genuineparttype.Part;
}